/**
 * "Trova il prodotto adatto a te" — quiz engine.
 *
 * Reads two JSON blobs rendered by sections/product-quiz.liquid: the product
 * taxonomy and the question/answer blocks. Liquid cannot group a flat block
 * list into nested questions, so that grouping happens here: a "domanda" block
 * opens a question and every "risposta" after it belongs to it.
 *
 * Matching: area is a hard filter, esigenza and pelle score. A product marked
 * "tutti i tipi" scores on any skin type, but below an exact match, so a
 * product formulated for dry skin outranks a general one for a dry-skin answer.
 */
(function () {
  'use strict';

  var SCORE = { esigenza: 3, pelle: 2, pelleGeneric: 1 };
  var GENERIC_SKIN = 'tutti i tipi';

  function parseJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }


  /**
   * Default questions, used when the section has no "domanda" blocks.
   *
   * A section rendered statically by {% section %} does not receive its
   * preset's blocks, so without these the quiz would do nothing until someone
   * hand-built twenty-odd blocks in the theme editor. Adding any question
   * block in the customizer replaces this set entirely.
   *
   * The skin question is worded as symptoms rather than categories: most
   * people cannot classify their own skin, and asking them to is where
   * quizzes lose people. "Non saprei" is a real, unpenalised answer.
   */
  var DEFAULTS = [
    { text: 'Di cosa ti vuoi prendere cura?', field: 'area', max: 1, skipForArea: '',
      answers: [
        { label: 'Viso', value: 'viso' },
        { label: 'Corpo', value: 'corpo' },
        { label: 'Contorno occhi', value: 'contorno occhi' },
        { label: 'Labbra', value: 'labbra' },
        { label: 'Capelli', value: 'capelli' },
        { label: 'Mani', value: 'mani' }
      ] },
    { text: "Com'è la tua pelle, di solito?", field: 'pelle', max: 1, skipForArea: 'capelli',
      hint: 'Scegli la descrizione che ti somiglia di più.',
      answers: [
        { label: 'Tira dopo la detersione', value: 'secca', note: 'Sensazione di pelle che tira, a volte desquama' },
        { label: 'Molto secca e screpolata', value: 'molto secca', note: 'Ruvida al tatto, si screpola facilmente' },
        { label: 'Si arrossa facilmente', value: 'sensibile', note: 'Reagisce a prodotti nuovi, freddo, vento' },
        { label: 'Lucida sulla zona T', value: 'mista', note: 'Fronte e naso lucidi, guance normali' },
        { label: 'Ha perso tono ed elasticità', value: 'matura' },
        { label: 'Normale, nessun fastidio', value: 'normale' },
        { label: 'Non saprei', value: '' }
      ] },
    { text: 'Cosa vorresti migliorare?', field: 'esigenza', max: 2,
      hint: 'Puoi scegliere fino a due risposte.',
      answers: [
        { label: 'Idratare', value: 'idratazione' },
        { label: 'Nutrire in profondità', value: 'nutriente' },
        { label: 'Detergere', value: 'detersione' },
        { label: 'Contrastare i segni del tempo', value: 'anti-età' },
        { label: 'Rassodare', value: 'rassodante' },
        { label: 'Lenire e calmare', value: 'lenitiva' },
        { label: 'Esfoliare', value: 'esfoliante' },
        { label: 'Illuminare', value: 'illuminante' }
      ] }
  ];

  function build(root) {
    var start = root.querySelector('[data-quiz-start]');
    var products = parseJSON(root.querySelector('[data-quiz-products]')) || [];
    var config = parseJSON(root.querySelector('[data-quiz-config]'));

    // A dead button with no explanation is the worst failure mode here, so say
    // what is wrong instead of returning silently.
    if (!start) return;
    if (!config || !products.length) {
      start.addEventListener('click', function () {
        root.querySelector('[data-quiz-stage]').hidden = false;
        root.querySelector('[data-quiz-stage]').textContent =
          'Il quiz non trova i prodotti. Controlla che i metacampi Area, Pelle ed Esigenza siano compilati.';
      });
      return;
    }

    // group the flat block list into questions
    var questions = [];
    config.blocks.forEach(function (b) {
      if (b.type === 'domanda') {
        questions.push({
          text: b.question, hint: b.hint, field: b.field,
          max: Math.max(1, parseInt(b.max, 10) || 1),
          skipForArea: b.skipForArea, answers: []
        });
      } else if (b.type === 'risposta' && questions.length) {
        questions[questions.length - 1].answers.push({
          label: b.label, value: b.value, note: b.note
        });
      }
    });
    if (!questions.length) questions = DEFAULTS.slice();

    var intro = root.querySelector('[data-quiz-intro]');
    var stage = root.querySelector('[data-quiz-stage]');
    var wanted = parseInt(root.getAttribute('data-quiz-results'), 10) || 3;

    var answers = {};   // field -> [values]
    var path = [];      // indexes of the questions actually shown
    var at = 0;

    function activeQuestions() {
      var area = (answers.area || [])[0];
      return questions.filter(function (q) {
        return !(q.skipForArea && area && q.skipForArea === area);
      });
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function renderQuestion() {
      var list = activeQuestions();
      if (at >= list.length) return renderResults();
      var q = list[at];

      stage.innerHTML = '';

      var bar = el('div', 'quiz__progress');
      var fill = el('span', 'quiz__progress-fill');
      fill.style.width = ((at) / list.length * 100) + '%';
      bar.appendChild(fill);
      stage.appendChild(bar);

      stage.appendChild(
        el('p', 'quiz__step',
          (config.stepLabel || '')
            .replace('[n]', at + 1)
            .replace('[tot]', list.length))
      );

      var fs = el('fieldset', 'quiz__question');
      fs.appendChild(el('legend', 'quiz__legend', q.text));
      if (q.hint) fs.appendChild(el('p', 'quiz__hint', q.hint));

      var opts = el('div', 'quiz__options');
      var chosen = (answers[q.field] || []).slice();

      q.answers.forEach(function (a) {
        var btn = el('button', 'quiz__option');
        btn.type = 'button';
        btn.setAttribute('aria-pressed', chosen.indexOf(a.value) > -1 ? 'true' : 'false');
        btn.appendChild(el('span', 'quiz__option-label', a.label));
        if (a.note) btn.appendChild(el('span', 'quiz__option-note', a.note));

        btn.addEventListener('click', function () {
          var i = chosen.indexOf(a.value);
          if (i > -1) {
            chosen.splice(i, 1);
          } else {
            if (q.max === 1) chosen.length = 0;
            else if (chosen.length >= q.max) return;
            chosen.push(a.value);
          }
          answers[q.field] = chosen.slice();
          if (q.max === 1) { advance(); return; }
          renderQuestion();
        });
        opts.appendChild(btn);
      });
      fs.appendChild(opts);
      stage.appendChild(fs);

      var nav = el('div', 'quiz__nav');
      if (at > 0) {
        var back = el('button', 'quiz__nav-btn', config.backLabel);
        back.type = 'button';
        back.addEventListener('click', function () { at = Math.max(0, at - 1); renderQuestion(); });
        nav.appendChild(back);
      }
      if (q.max > 1) {
        var next = el('button', 'btn quiz__nav-next', config.nextLabel);
        next.type = 'button';
        next.disabled = !chosen.length;
        next.addEventListener('click', advance);
        nav.appendChild(next);
      }
      stage.appendChild(nav);

      var first = opts.querySelector('.quiz__option');
      if (first) first.focus();
    }

    function advance() { at++; renderQuestion(); }

    function score(p) {
      var pts = 0, why = [];
      (answers.esigenza || []).forEach(function (v) {
        if (p.esigenza.indexOf(v) > -1) { pts += SCORE.esigenza; why.push(v); }
      });
      (answers.pelle || []).forEach(function (v) {
        if (p.pelle.indexOf(v) > -1) { pts += SCORE.pelle; why.push('pelle ' + v); }
        else if (p.pelle.indexOf(GENERIC_SKIN) > -1) { pts += SCORE.pelleGeneric; }
      });
      return { pts: pts, why: why };
    }

    function renderResults() {
      var area = (answers.area || [])[0];
      var pool = products.filter(function (p) { return !area || p.area === area; });

      var ranked = pool.map(function (p) {
        var s = score(p);
        return { p: p, pts: s.pts, why: s.why };
      }).filter(function (r) {
        // Only recommend what we can give a reason for. A product that merely
        // says "tutti i tipi" is not an answer to "ho la pelle grassa", and
        // showing it under "perché te lo consigliamo" with nothing to say
        // reads as padding. Better to return two good matches than three.
        return r.why.length > 0;
      }).sort(function (a, b) {
        if (b.pts !== a.pts) return b.pts - a.pts;
        if (a.p.available !== b.p.available) return a.p.available ? -1 : 1;
        return 0;
      }).slice(0, wanted);

      stage.innerHTML = '';
      stage.appendChild(el('h2', 'quiz__results-title', config.resultsTitle));

      if (!ranked.length) {
        stage.appendChild(el('p', 'quiz__lead', config.emptyText));
      } else {
        stage.appendChild(el('p', 'quiz__lead', config.resultsLead));

        var grid = el('div', 'quiz__results');
        ranked.forEach(function (r) {
          var card = el('article', 'quiz__card');
          var a = el('a', 'quiz__card-link');
          a.href = r.p.url;
          if (r.p.image) {
            var img = document.createElement('img');
            img.className = 'quiz__card-img';
            img.src = r.p.image;
            img.alt = r.p.title;
            img.loading = 'lazy';
            a.appendChild(img);
          }
          a.appendChild(el('h3', 'quiz__card-title', r.p.title));
          card.appendChild(a);
          card.appendChild(el('p', 'quiz__card-price', r.p.price));

          if (r.why.length) {
            var reason = el('p', 'quiz__card-why');
            reason.appendChild(el('strong', null, config.reasonPrefix + ' '));
            reason.appendChild(document.createTextNode(r.why.join(', ')));
            card.appendChild(reason);
          }

          var add = el('button', 'btn btn--secondary quiz__card-add', config.addOneLabel);
          add.type = 'button';
          add.disabled = !r.p.available;
          add.addEventListener('click', function () { addToCart([r.p.variant], add); });
          card.appendChild(add);

          grid.appendChild(card);
        });
        stage.appendChild(grid);

        var ids = ranked.filter(function (r) { return r.p.available; })
                        .map(function (r) { return r.p.variant; });
        if (ids.length > 1) {
          var all = el('button', 'btn quiz__add-all', config.addAllLabel);
          all.type = 'button';
          all.addEventListener('click', function () { addToCart(ids, all); });
          stage.appendChild(all);
        }
      }

      var again = el('button', 'quiz__restart', config.restartLabel);
      again.type = 'button';
      again.addEventListener('click', function () {
        answers = {}; at = 0; renderQuestion();
      });
      stage.appendChild(again);
    }

    function addToCart(ids, button) {
      var original = button.textContent;
      button.disabled = true;
      button.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    }

    start.addEventListener('click', function () {
      intro.hidden = true;
      stage.hidden = false;
      renderQuestion();
    });
    start.disabled = false;
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-quiz]'), function (r) {
      try { build(r); } catch (e) { /* never break the page */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
